import React from 'react';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import { Link as RouterLink, NavLink as RouterNavLink } from 'react-router-dom';
import * as routes from '@src/Routes/links';
import { createLink } from '@src/util/createLink';

const LinkBase = Component =>
  function Link({ children, to, params, queryParams, ...props }) {
    Link.propTypes = {
      children: PropTypes.node.isRequired,
      params: PropTypes.object,
      queryParams: PropTypes.object,
      to: PropTypes.oneOf(map(routes)).isRequired,
    };

    return (
      <Component
        {...props}
        to={createLink({
          link: to,
          params: params,
          queryParams: queryParams,
        })}
      >
        {children}
      </Component>
    );
  };

export const Link = LinkBase(RouterLink);
export const NavLink = LinkBase(RouterNavLink);
